<template>
  <div
    class="dropdown-menu-button"
    :class="getMenuButtonClasses"
  >
    <NuxtLink
      :to="to"
      class="dropdown-menu-button__link"
      @click="
        useMixpanelTrack('lb2 desktop carrier-profile link clicked', {
          from: route.fullPath,
        })
      "
    >
      <div class="dropdown-menu-button__user-icon">
        <span data-testid="dropdown-menu-button__user-icon">
          {{ currentUserInitials }}
        </span>
      </div>
      <div class="dropdown-menu-button__user-info">
        <div class="dropdown-menu-button__full-name subtitle-2">
          <ui-badge state="success">
            <span
              class="tw-mr-2"
              data-testid="dropdown-menu-button__full-name"
            >
              {{ userName }}
            </span>
            <template #badge><span class="tw-px-2">New</span></template>
          </ui-badge>
        </div>
        <div
          class="dropdown-menu-button__carrier-name"
          data-testid="dropdown-menu-button__carrier-name"
        >
          {{ companyName }}
        </div>
      </div>
    </NuxtLink>

    <UiButton
      class="dropdown-menu-button__menu-icon"
      @click="emit('toggleAction')"
      data-testid="menu-button__menu-icon"
    >
      <ui-icon type="round"> menu </ui-icon>
    </UiButton>
  </div>
</template>

<script setup>
import { storeToRefs } from 'pinia';
import { useUserDetailsStore } from '@/stores/useUserDetails';

const route = useRoute();

const emit = defineEmits(['toggleAction', 'clickProfile']);

const props = defineProps({
  isProfile: {
    type: Boolean,
    default: false,
  },
  to: {
    type: String,
    default: '',
  },
});

const { currentUserInitials, userName, companyName } = storeToRefs(useUserDetailsStore());

const getMenuButtonClasses = computed(() => {
  return [props.isProfile ? 'dropdown-menu-button--profile' : ''];
});
</script>

<style lang="scss" scoped>
@use '@/assets/scss/fonts.scss';

.dropdown-menu-button {
  @apply tw-flex tw-flex-row tw-items-center tw-justify-center;

  &.dropdown-menu-button--profile {
    @apply tw-justify-start;

    .dropdown-menu-button__link {
      @apply tw-w-full tw-justify-start;
    }

    .dropdown-menu-button__user-icon {
      margin-right: 18px;
      width: 33px;
      height: 33px;
    }
    .dropdown-menu-button__full-name {
      @apply tw-mb-1 tw-text-base tw-leading-6 tw-text-grey-dark-x;
      letter-spacing: 0.25px;
    }
    .dropdown-menu-button__carrier-name {
      @apply tw-text-sm;
      letter-spacing: 0.25px;
      line-height: 21px;
    }
    .dropdown-menu-button__user-info {
      @apply tw-block;
    }
  }
}

.dropdown-menu-button__link {
  @apply tw-flex tw-cursor-pointer tw-flex-row tw-items-center tw-justify-center tw-text-black-500 tw-no-underline;
}
.dropdown-menu-button__user-icon {
  @apply tw-bg-primary-base tw-text-center tw-font-medium tw-capitalize tw-text-white;

  height: 30px;
  width: 30px;
  border-radius: 100px;
  font-size: 16px;
  line-height: 30px;

  @screen tw-md {
    margin-right: 10px;
  }
}

.dropdown-menu-button__user-info {
  @apply tw-hidden tw-flex-col tw-items-start tw-md:tw-flex;
  padding-right: 23px;
  line-height: 1;
}

.dropdown-menu-button__full-name {
  @apply tw-mb-1 tw-text-left tw-font-medium tw-text-grey-dark;
}

.dropdown-menu-button__carrier-name {
  @apply tw-text-xs tw-font-regular tw-capitalize tw-text-grey-dark;
}

.dropdown-menu-button__menu-icon {
  @apply tw-hidden tw-text-grey-dark tw-md:tw-flex;
}

.dropdown-menu-button__admin {
  @apply tw-relative -tw-top-1 tw-left-3 tw-scale-75 tw-rounded-full tw-border tw-border-solid tw-bg-white tw-p-1 tw-text-drivably-primary-base;
}
</style>
